// CalibrationLogTab.js
// Thin adapter that wires the Sampling Event form into the shared CalibrationLogSection.
// The actual calibration UI/behavior lives in features/shared/calibrationLog (reused by the
// standalone Calibration Log Book as well).

import React from "react";
import { CalibrationLogSection } from "../../../shared/calibrationLog/CalibrationLogSection";

export const CalibrationLogTab = ({ samplingEventData, tabProps, actions }) => {
  const clActions = actions?.samplingEventFormActions?.calibrationLogs || {};

  return (
    <CalibrationLogSection
      getSortedLogs={() => samplingEventData?.sortWaterCalibrationLogs()}
      ui={tabProps?.calibrationLogUI || {}}
      clActions={clActions}
      emitPatch={tabProps?.emitPatch}
      user={tabProps?.user}
      meters={tabProps?.samplingEquipmentMeters || []}
      getExistingLogById={(id) =>
        samplingEventData?.waterCalibrationLogs?.find((log) => log.id === id)
      }
      parentData={samplingEventData}
      sectionTitle="Water Quality Meter Calibration Log"
    />
  );
};
